import React from 'react'

const { func, array } = React.PropTypes

function RagicSyncer ({ syncToRagic, result }) {
  return (
    <div>
      <button className="btn btn-primary" onClick={syncToRagic} >同步至線上伺服器</button>
      <div>
        {result.map((row, index) => (
          <div key={index}>{row}</div>
        ))}
      </div>
    </div>
  )
}
RagicSyncer.propTypes = {
  syncToRagic: func,
  result: array,
}

export default RagicSyncer



// WEBPACK FOOTER //
// ./src/components/RagicSyncer/RagicSyncer.jsx